import React from "react";

export const getLoadingSpan = () => {
  return <label className='loading-label'><span className={`spinner-grow spinner-grow-sm mr-1`} role="status" /></label>
};